import { render, staticRenderFns } from "./PxLogin.vue?vue&type=template&id=18a2068a&scoped=true&"
import script from "./PxLogin.vue?vue&type=script&lang=js&"
export * from "./PxLogin.vue?vue&type=script&lang=js&"
import style0 from "./PxLogin.vue?vue&type=style&index=0&id=18a2068a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a2068a",
  null
  
)

export default component.exports